import Form from "./Form"
export const VCliente = () => {
    return (
        <div>
            <Form/>
        </div>
    )
}
export default VCliente